import { render, staticRenderFns } from "./lampPolice.vue?vue&type=template&id=2c06c0b4&scoped=true"
import script from "./lampPolice.vue?vue&type=script&lang=js"
export * from "./lampPolice.vue?vue&type=script&lang=js"
import style0 from "./lampPolice.vue?vue&type=style&index=0&id=2c06c0b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c06c0b4",
  null
  
)

export default component.exports